import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";

export function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <Result
      status="404"
      title="Page not found"
      extra={
        <Button type="primary" onClick={() => navigate("/")}>
          Back home
        </Button>
      }
    />
  );
}
